import { ReferenceManyField, Tab, TabProps, TextField } from 'react-admin';
import { CheckRecordActiveSwitch } from '@/pages/Candidate/view/utils';
import { MainDatagridStyled } from '@/styles/overrides';
import { FCRAWorkerCheckRecordTypeEnum, TurnReferencesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { path } from './constants';

const MvrViolationTab = (props: Partial<TabProps>) => {
  return (
    <Tab label="Violations" {...props}>
      <ReferenceManyField
        label=""
        reference={TurnReferencesEnum.Candidates}
        target={TurnTargetsEnum.WorkerMvrViolations}
      >
        <MainDatagridStyled bulkActionButtons={false} rowClick={false}>
          <CheckRecordActiveSwitch type={FCRAWorkerCheckRecordTypeEnum.MvrViolation} />
          <TextField emptyText="false" sortable={false} source={path('active')} />
          <TextField label="ID" sortable={false} source={path('id')} />
          <TextField label="Incident Date" sortable={false} source={path('incident_date')} />
          <TextField label="Conviction Date" sortable={false} source={path('conviction_date')} />
          <TextField label="Docket" sortable={false} source={path('locations.0.docket')} />
          <TextField label="Court" sortable={false} source={path('locations.0.court')} />
          <TextField label="State" sortable={false} source={path('locations.0.state')} />
          <TextField label="ACD Code" sortable={false} source={path('sub_violations.0.acd_code')} />
          <TextField label="ACD Description" sortable={false} source={path('sub_violations.0.acd_code_description')} />
          <TextField
            label="Short Description"
            sortable={false}
            source={path('sub_violations.0.descriptions.0.short_description')}
          />
          <TextField
            label="State Description"
            sortable={false}
            source={path('sub_violations.0.descriptions.0.state_description')}
          />
        </MainDatagridStyled>
      </ReferenceManyField>
    </Tab>
  );
};

export default MvrViolationTab;
